"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOrDelete = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
function setOrDelete(object, prop, value) {
    if (isEmpty_1.default(value)) {
        delete object[prop];
    }
    else {
        object[prop] = value;
    }
}
exports.setOrDelete = setOrDelete;
//# sourceMappingURL=setOrDelete.js.map